import { render, staticRenderFns } from "./AppstauberWidget.vue?vue&type=template&id=48713c48&scoped=true"
import script from "./AppstauberWidget.vue?vue&type=script&lang=js"
export * from "./AppstauberWidget.vue?vue&type=script&lang=js"
import style0 from "./AppstauberWidget.vue?vue&type=style&index=0&id=48713c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48713c48",
  null
  
)

export default component.exports